import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { APP_BASE_HREF } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class PolicyService {

  url = "";

  constructor(private http: HttpClient, @Inject(APP_BASE_HREF) private baseHref: string) {
    this.url = baseHref + environment.apis.policy;
  }

  getIdConsentByProductAlias(productAlias: string) {
    return this.http.get<any>(`${this.url}/consents/${productAlias}`);
  }
}
